import { cn } from "@/lib/utils";

export type ApiEndpointRow = [method: string, endpoint: string, description: string];

type ApiEndpointsTableProps = {
  rows: ApiEndpointRow[];
  title?: string;
  className?: string;
};

export function ApiEndpointsTable({ rows, title, className }: ApiEndpointsTableProps) {
  return (
    <div className={className}>
      {title != null && (
        <h3 className="font-mono text-sm uppercase tracking-widest text-muted-foreground">
          {title}
        </h3>
      )}
      <div className="mt-6 overflow-hidden rounded-lg border border-border/60">
        <table className="w-full min-w-[480px] border-collapse text-sm">
          <thead>
            <tr className="border-b border-border/60 bg-muted/30">
              <th className="px-4 py-3 text-left font-mono text-xs font-medium uppercase tracking-wider text-muted-foreground">
                Method
              </th>
              <th className="px-4 py-3 text-left font-mono text-xs font-medium uppercase tracking-wider text-muted-foreground">
                Endpoint
              </th>
              <th className="px-4 py-3 text-left font-mono text-xs font-medium uppercase tracking-wider text-muted-foreground">
                説明
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map(([method, endpoint, desc]) => (
              <tr
                key={endpoint}
                className="border-b border-border/60 last:border-b-0 transition-colors hover:bg-muted/10"
              >
                <td className="px-4 py-3">
                  <span className="inline-block rounded bg-muted/40 px-2 py-0.5 font-mono text-xs font-medium text-foreground/80">
                    {method}
                  </span>
                </td>
                <td className="px-4 py-3 font-mono text-xs text-foreground/90">{endpoint}</td>
                <td className="px-4 py-3 text-muted-foreground">{desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
